import type {
  DeviceType,
  TableRequestBody,
  TableRequestColumns,
} from '@ipfabric/utils';
import type { DeviceDetailData } from './HostnameDetailContent';

interface RequestPayload {
  sn: string;
  snapshotId: string;
}

export interface DeviceDataForDeviceViewSettings extends DeviceDetailData {
  devType: DeviceType | null;
  icon: DeviceType | null;
}

interface DevicesRequest {
  url: string;
  method: string;
  data: TableRequestBody<DeviceDataForDeviceViewSettings>;
}

export const getDeviceDetailRequestPayload = ({
  sn,
  snapshotId,
}: RequestPayload): DevicesRequest => {
  const columns: TableRequestColumns<DeviceDataForDeviceViewSettings> = [
    'family',
    'hostname',
    'id',
    'image',
    'loginIpv4',
    'loginIpv6',
    'loginType',
    'loginPort',
    'memoryUtilization',
    'model',
    'platform',
    'processor',
    'rd',
    'reload',
    'siteName',
    'sn',
    'stpDomain',
    'taskKey',
    'uptime',
    'vendor',
    'version',
    'configReg',
    'devType',
    'icon',
    'slug',
  ];
  return {
    url: '/tables/inventory/devices',
    method: 'POST',
    data: {
      columns,
      filters: { sn: ['eq', sn] },
      snapshot: snapshotId,
    },
  };
};
